export const COLLEGECONFERENCE_LABEL_PROPERTIES = [  { key: "name", type: "String" },];
export interface CollegeConferenceProperties {
  name: string;
}